import { API, /* baseClient, */ authClient } from "../../utils/index";

export const getSurveyAnswersBySurvey = (surveyId) => {
	return authClient().get(`${API}/survey-answer/by-survey/${surveyId}`);
};
